var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MultiselectElement',{attrs:{"value":_vm.selectedAgent,"options":_vm.agentList,"label":this.$t('label.agent._'),"type":_vm.type,"with-error":_vm.withError,"error-message":_vm.errorMessage,"disabled":_vm.disabled,"required":_vm.required},on:{"select":_vm.onSelect,"searchChange":_vm.onSearchChange,"open":_vm.onOpen}})
}
var staticRenderFns = []

export { render, staticRenderFns }